import styled from "@emotion/styled";
import { resetButton } from "shared/styles/mixin";

export const Category = styled.div`
    display: flex;
    flex-direction: column;
    text-transform: initial;
    flex-wrap: wrap;
    height: 100%;

    .ch-anc {
        ${resetButton}
        height: 100%;
        color: #666;
        text-decoration: none;
        cursor: pointer;
        line-height: 1.79;
        flex: 1 1 0;
        position: relative;
        align-items: center;
        padding: 0 20px;
        display: flex;
        font-size: 14px;
        background-color: #fff;

        &:hover {
            color: #000;
        }
    }

    .selectedBrand {
        font-weight: 500;
        color: #000;
        background-color: transparent;
    }

    .icon {
        transform: rotate(180deg);
        position: absolute;
        right: 5px;
    }
`;
